import React, { useEffect, useState } from 'react'
import img5 from '../Assets/video5.png.png'
import { Get_Api } from '../Api_Url';

function AllGallary() {
    const [AllGallary, setAllGallary] = useState([]);
    const [IsUploading, setIsUploading] = useState(false);
    const getGallary = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllGallay`);
            setAllGallary(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        getGallary();
    }, []);


    return (
        <div>
            <div className='Gallery'>
                <p>Gallery</p>
                <h3>Journey to the most Beautiful<br /> places on earth</h3>
                <br />
                <br />
                <div className='Gallery-grid'>
                    {AllGallary?.map((item) => (
                        <img key={item?._id} src={item?.Image || img5} alt="Gallery" />
                    ))}
                </div>
                <br />
                <br />
                <div className='line-btn'>
                    <div className='line'></div>
                    <button>View All</button>
                    <div className='line'></div>
                </div>
            </div>
        </div>
    )
}

export default AllGallary